export default __webpack_public_path__ + "static/media/document-card-background.2bd78827.svg";